export default "__VITE_ASSET__BL$o1DpF__"